<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gkt8aC/tc-custom/9781640808546.jpg?1718282658783" alt="This image is the cover for the book Doctor's Secret, Copper Point Medical"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Doctor's Secret, Copper Point Medical
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i></i></b></p><p><b>Cullinan weaves themes of racism and Asian culture, family pressures, and the value of friends, home, and love into a deeply satisfying romance. </b></p><p>— Publishers Weekly, <b>Starred Review</b></p><p><b><i>Copper Point Medical: Book One</i></b></p><p>The brilliant but brooding new doctor encounters Copper Point's sunny nurse-next-door... and nothing can stand in the way of this romance.</p><p>Dr. Hong-Wei Wu has come to Copper Point, Wisconsin, after the pressures of a high-powered residency burned him out of his career before he started. Ashamed of letting his family down after all they’ve done for him, he plans to live a quiet life as a simple surgeon in this tiny northern town. His plans, however, don’t include his outgoing, kind, and attractive surgical nurse, Simon Lane.</p><p>Simon wasn’t ready for the new surgeon to be a handsome charmer who keeps asking him for help getting settled and who woos him with amazing Taiwanese dishes. There’s no question—Dr. Wu is flirting with him, and Simon is flirting back. The problem is, St. Ann’s has a strict no-dating policy between staff, which means their romance is off the table… unless they bend the rules. </p><p>But a romance that keeps them—literally—in the closet can’t lead to happy ever after. Simon doesn’t want to stay a secret, and Hong-Wei doesn’t want to keep himself removed from life, not anymore. To secure their happiness, they’ll have to change the administration’s mind. But what other secrets will they uncover along the way, about Copper Point… and about each other?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heidi Cullinan
      </h2>
      
      <p class="authorDescription body article"><P>Author of over thirty novels, Midwest-native Heidi Cullinan&#160;writes positive-outcome romances for LGBT characters struggling against insurmountable odds because they believe there&rsquo;s no such thing as too much happy ever after. Heidi&rsquo;s books have been recommended by&#160;<I>Library Journal</I>,&#160;<I>USA Today</I>,&#160;<I>RT Magazine</I>, and&#160;<I>Publishers Weekly</I>. When Heidi isn&rsquo;t writing, they enjoy gaming, reading manga, manhua, and danmei, playing with cats, and watching too much anime.</P><P>&#160;Heidi goes by Jun when being spoken to in person or online, and Jun&rsquo;s pronouns are they/them.</P><P>Visit Heidi&rsquo;s website at&#160;<a href="https://www.google.com/url?q=http://www.heidicullinan.com&amp;sa=D&amp;source=calendar&amp;ust=1619365394361000&amp;usg=AOvVaw1bjZm7rMYa0qNvsIAbLzHe">www.heidicullinan.com</a>.<BR /><BR />You can contact her at&#160;<a href="mailto:heidi@heidicullinan.com">heidi@heidicullinan.com</a>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09a474d3